function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineDocument } from 'sanity-typed-queries';
import { TaxonomyType } from '@stereoagency/constants';
import { arrayEntry, internationalizedArrayPageSections, internationalizedArraySimpleBlockContent, internationalizedArrayString, sanityReference, documentSlug } from '../fragments/index.js';
import taxonomy from './taxonomy.js';
import profile from './profile.js';
import researchGroup from './researchGroup.js';
import researchPlatform from './researchPlatform.js';
var schema = defineDocument('researchProject', {
    slug: _object_spread({
        title: 'Slug'
    }, documentSlug.factory()),
    title: {
        title: 'Title',
        type: 'internationalizedArrayString'
    },
    introduction: {
        title: 'Introduction',
        type: 'internationalizedArraySimpleBlockContent'
    },
    content: {
        title: 'Content',
        type: 'internationalizedArrayPageSections'
    },
    datetime: {
        title: 'Datetime',
        type: 'datetime',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    timezone: {
        title: 'Timezone',
        type: 'string',
        description: 'Leave blank to use the current timezone',
        options: {
            list: typeof Intl.supportedValuesOf !== 'undefined' ? Intl.supportedValuesOf('timeZone') : []
        }
    },
    author: {
        title: 'Author',
        type: 'reference',
        to: [
            {
                type: 'profile'
            }
        ]
    },
    taxonomies: {
        title: 'Taxonomies',
        type: 'array',
        of: [
            {
                type: 'reference',
                to: [
                    {
                        type: 'taxonomy'
                    }
                ],
                options: {
                    filter: 'type in $types',
                    filterParams: {
                        types: [
                            TaxonomyType.DISEASE_AREA
                        ]
                    }
                }
            }
        ]
    },
    linkedResearchContent: {
        title: 'Research group or platform',
        type: 'reference',
        to: [
            {
                type: 'researchGroup'
            },
            {
                type: 'researchPlatform'
            }
        ]
    }
}, [
    profile.schema.profile,
    taxonomy.schema.taxonomy,
    researchGroup.schema.researchGroup,
    researchPlatform.schema.researchPlatform,
    {},
    {},
    {}
]);
var validator = z.object({
    slug: documentSlug.validator,
    title: internationalizedArrayString.validator,
    introduction: internationalizedArraySimpleBlockContent.validator,
    content: internationalizedArrayPageSections.validator,
    datetime: z.string(),
    timezone: z.string(),
    author: sanityReference.validator,
    taxonomies: z.array(sanityReference.validator.merge(arrayEntry.validator)),
    linkedResearchContent: sanityReference.validator
}).partial();
schema.researchProject;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=researchProject.js.map